import { AppMode, BetbyBonusBehavior, CatalogFilter, EndpointType, Theme } from '../types.js';
const themeSetting = {
    theme: Theme.Luna,
    rankConfig: { sublevelFormat: 'numeric' },
    betbyEnabled: true,
    betbyBonusBehavior: BetbyBonusBehavior.NoBonusMoney,
    betbyThemeName: 'default',
    sportmodity: {
        enabled: true,
        style: 'dark',
        isUsLayout: false
    },
    brand: 'lunabet.com',
    brandTitle: 'Lunabet',
    canonicalUrl: 'https://lunabet.com',
    cdnBase: 'https://d3r5y5kwxjm7vw.cloudfront.net',
    cdnBaseFallbacks: ['https://luna.gmcdn.org'],
    cdnTiles: 'https://tiles.fomo.io',
    cdnBanners: 'https://images.fomo.io/',
    cubePayEnabled: true,
    discordLink: '',
    googleAnalytics: '',
    googleClientId: undefined, //'1030216308308-9ceh2uirt0ltfdb0duunbmg83kp41s9a.apps.googleusercontent.com',
    googleTagManager: undefined,
    languageDefault: 'tr',
    languages: ['en', 'tr'],
    languagesTiles: ['en', 'tr'],
    languagesAutoAccept: ['en', 'tr'],
    intercomId: 'e6olp9gz',
    supportEmail: 'support@lunabet.com',
    telegramLink: undefined,
    xLink: undefined,
    noIndex: true,
    gameSetLimit: 60,
    themePath: 'fomoio',
    verbiageLabel: 'fomoio',
    ui: {
        mobileMenu: {
            mobileMenuStyle: 'alternative4',
            showRewardsAndPromo: false,
            showChat: false,
            showLunaSpecialBets: true,
            showJackpot: true,
            itemOrder: ['menu', 'sports', 'luna-special-bets', 'casino', 'jackpot']
        },
        accordion: {
            accordionStyle: 'alternative4'
        },
        auth: {
            useSolidAccentOAuthButton: true,
            showWalletConnect: false,
            useTightModalBodyPadding: true,
            useOffsetModalCloseButton: false,
            hideReferalCode: true
        },
        background: {
            backgroundStyle: 'solid'
        },
        bannerSwiper: {
            bannerSwiperStyle: 'alternative'
        },
        cardSwiper: {
            cardSwiperStyle: 'alternative4',
            viewAllAsButton: false,
            showNavigationArrows: true,
            disableEdgeMask: true
        },
        button: {
            buttonStyle: 'contrast',
            useUppercaseAsDefault: true
        },
        betby: {
            betslipBottom: 20,
            customUI: true
        },
        betfeed: {
            betfeedStyle: 'default',
            usedVerbiage: 'live'
        },
        cashier: {
            useAcceptDeclineBonusType: true,
            withdrawOnlyUsdt: true,
            withdrawOnlyUsdtMemeCoins: true,
            showConversionRateDeposit: false,
            showWiddrawalOnlyUSDT: false,
            showProgressBarBonusMoney: false,
            useBuyCryptoIFrame: false,
            buyCryptoMaxAmount: 5000,
            buyCryptoMinAmount: 15,
            showQrCodeBuyCrypto: false,
            useSearchInputOnCryptoDropdown: false,
            showImageOnDepositBonusOffers: true,
            depositBonusWageringContributions: [
                { category: 'slots', percentage: 100 },
                { category: 'originals', percentage: 5 },
                { category: 'live_casino', percentage: 0 },
                { category: 'table_games', percentage: 0 }
            ],
            showWithdrawalWarningIfNoFunds: true,
            showWithdrawalPlayRequirementImmediately: true,
            cashierStyle: 'alternative4',
            useCashierHomeScreen: true,
            useSidetabs: false,
            buyCryptoEnabled: false,
            useCashierV4: false,
            useCompactDepositAddressOptionLayout: true,
            extendCashierVerbiageKeysWithBrandLabel: true,
            useVerificationStep: true
        },
        casinoLobby: {
            casinoLobbyStyle: 'alternative4',
            showLiveWins: true,
            useAlternateOriginalsCategoryTitle: true
        },
        chat: {
            chatStyle: 'alternative4',
            requiredLanguageVerbiage: 'english'
        },
        checkbox: {
            useAlternativeTick: false,
            checkboxStyle: 'alternative'
        },
        dropdown: {
            dropdownStyle: 'alternative4',
            useDropdownBackgroundImage: false
        },
        emailVerify: {
            emailVerifyStyle: 'alternative4'
        },
        footer: {
            footerStyle: 'alternative4',
            useEmbeddedShellDecor: false
        },
        games: {
            showRacesLeaderboard: false,
            showNavigationOnMobile: false,
            showLikeButton: false,
            showLogoWhenPlayingDesktop: false,
            showGameInfoModalOnGamePathMobile: false,
            applyPedestalIllustrationHueShift: true,
            useCompactRacesLeaderboardInfoBackdrop: true,
            showRacesLeaderboardPerimeterIllustrations: false
        },
        header: {
            headerStyle: 'alternative4',
            buttonLoginVariant: 'secondary',
            useTightRewardsToggleHorizontalPadding: false
        },
        helpdesk: {
            useDynamicBonusTerms: true
        },
        home: {
            homeStyle: 'alternative4',
            showBuyCryptoBanner: false,
            showLiveWins: true,
            cryptoBannerStyle: 'alternative',
            buyCryptoBannerArtStyle: 'minimal',
            useAlternateOriginalsCategoryTitle: true,
            showAdventCalendarPage: false
        },
        icons: {
            vipHeaderGlyphDarkFill: false,
            statusIconsUseWarmPalette: true,
            expandSectionToggleUsesMintAccent: false,
            navIconPickerAllowRemoteAssets: true,
            navIconPickerUseBundledIconFactories: false
        },
        infoCard: {
            infoCardStyle: 'solid-dark'
        },
        input: {
            inputStyle: 'alternative'
        },
        layout: {
            layoutStyle: 'alternative4',
            isContrastTextColor: true,
            useCompactVerticalPagePadding: true,
            useReducedMarginsInHomePage: false,
            useCurrentColorSidebar: true,
            useReferralIconAnimated: false,
            useNewIcons: false,
            useRemoteIcons: false,
            showCryptoPriceDropdown: false,
            showNotInCatalogGames: false,
            showUpdownGameDropdown: false,
            useReferralBannerOnlyImageCustom: true,
            usePromoItemContentCustom: true,
            useCentralButtonOnMobileMenu: false,
            sectionIconSize: 24,
            useExpandedRankPresentation: true,
            useAlternateMobileSidebarBackdrop: true,
            embedWebSiteOrganizationJsonLd: false
        },
        liveWins: {
            liveWinsStyle: 'alternative',
            usedVerbiage: 'live_wins',
            useSpecialWinCards: false
        },
        loading: {
            useLottie: false,
            publicInitPageLoadDisplayFor: 3000,
            playerInitPageLoadDisplayFor: 3000,
            useCustomLoading: true
        },
        maintenance: {
            maintenanceStyle: 'default',
            contentSource: 'hardcoded',
            useUppercaseBrandTitle: true
        },
        geoblock: {
            contentSource: 'hardcoded'
        },
        modal: {
            modalStyle: 'tinted'
        },
        walletDropdown: {
            showBalancePreferenceToggles: false
        },
        notifications: {
            notificationsStyle: 'alternative4',
            useBorderedPlayerNotificationsIcon: true,
            useGradientPublicNotificationsIcon: true,
            useExtendedDepositNotificationTitles: true
        },
        toasts: {
            toastsStyle: 'default',
            isLocalIcon: true
        },
        profileModal: {
            profileModalStyle: 'alternative4',
            showFavouriteSection: false,
            useStarsBackgroundOnFavouriteToken: false,
            useTokenArtBackgroundOnDesktop: true,
            useCompactFavouriteTokenMobileCard: true
        },
        promotions: {
            showExpiredPromotions: false,
            useAspectRatioBoxDetailCustom: true,
            limitedCashbackExpired: new Date('2027-01-01T00:00:00Z').getTime(),
            promotionsStyle: 'alternative'
        },
        provider: {
            providerStyle: 'alternative4',
            useSolidPrimaryGameCountBadge: true,
            hideProvidersHeroTitle: true
        },
        referral: {
            referralDashboardBannerType: 'onlyImage',
            faqTitleStyle: 'headline',
            faqVisibilityPreset: 'all',
            accordionGlassStyle: false,
            rulesCardsStyle: 'illustrated',
            rulesFootnoteMuted: false,
            highlightStepTitles: true,
            rankProgressPalette: 'warm',
            usePrefixedVerbiageKeys: true,
            shareModalStyle: 'rich',
            shareMessageVariant: 'campaign',
            shareBannerStyle: 'elevated',
            referralDashboardBannerStyle: 'elevated'
        },
        transparency: {
            enabled: true
        },
        affiliates: {
            enabled: false,
            usePrefixedVerbiageKeys: true
        },
        rewardsDropdown: {
            rewardsDropdownStyle: 'alternative',
            useComfortableRewardsTimerLabels: true,
            showSeasonalRewardsCampaignTabs: false
        },
        seoText: {
            style: 'default'
        },
        settings: {
            settingsStyle: 'alternative',
            useAlternateSettingsChrome: true
        },
        sidebar: {
            sidebarStyle: 'alternative4',
            showLuckyDip: false,
            showBanner: false
        },
        table: {
            tableStyle: 'alternative'
        },
        tabs: {
            tabsStyle: 'alternative4',
            useCompactTabStripRadius: true,
            tabButtonsDefaultVariant: 'primary'
        },
        text: {
            successTextUsesWarmTone: true
        },
        toggle: {
            toggleStyle: 'alternative'
        },
        tooltip: {
            tooltipStyle: 'alternative'
        },
        topSection: {
            casinoTopSectionStyle: 'alternative'
        },
        transactions: {
            transactionsStyle: 'alternative',
            useSegmentedTabs: true,
            useElevatedRows: true,
            showEmptyStateIllustration: false
        },
        vip: {
            vipDashboardStyle: 'alternative4',
            vipAboutStyle: 'alternative',
            vipAboutStylePreview: 'alternative',
            useMarkdownFaqs: false,
            heroCardOpacity: 0.9,
            rewardsTableLayout: 'summary',
            rewardsProgressPalette: 'warm',
            includeWageringRequirementRow: true,
            reorderPrimaryBenefitCards: true,
            testimonialsHeaderStyle: 'headline',
            useCompactTestimonialsCardHeight: true,
            faqListLength: 'short',
            usePrefixedVerbiageKeys: true,
            assetSet: 'elevated',
            negativeBadgeTone: 'rose',
            showRankPrefixBeforeDisplayName: false,
            useAccentPendingTotalsBadge: true,
            useBorderOnMiniVipCalendarCard: true,
            useCompactClubOverviewSectionHeights: true,
            useCompactRoyaltyBannerTypography: true,
            useExpandedRoyaltyBannerSectionSpacing: true,
            useGradientVipCalendarDateHeader: false,
            useTallerRoyaltyBannerOnNarrowScreens: true,
            showRoyaltyBannerInDashboard: false,
            calendarSummaryLabel: 'claimed',
            includeRaceInRakebackBreakdown: false,
            showVipRewardTooltips: false,
            monthlyRewardsTooltipStyle: 'compact',
            useClassicVipCalendarCardChrome: false,
            rakeboostProgressTone: 'accent'
        },
        progressBar: {
            showProgressIcon: false
        },
        profileDropdown: {
            showSupport: false,
            profileDropdownStyle: 'alternative',
            useAlternateProfileMenuChrome: true
        }
    }
};
const themeSettings = [
    {
        ...themeSetting,
        brand: 'luna-gamma.previewenv.net',
        languages: ['en', 'tr'],
        noIndex: true
    }
];
export const getThemeSetting = (domain, fullDomain) => {
    const setting = themeSettings.find((s) => fullDomain.includes(s.brand));
    if (setting)
        return setting;
    return themeSetting;
};
export const endpointSettings = [
    {
        name: 'luna',
        theme: Theme.Luna,
        base: 'monopoly-luna.prod.infinitro.dev',
        baseCurrency: 'TRY',
        baseCurrencySymbol: '₺',
        baseCurrencyDigits: 2,
        realm: 'prod-luna',
        catalogFilter: CatalogFilter.ReleaseGames,
        endpointType: EndpointType.Production,
        reownProjectId: '441421829a4cc3f2eaf2cccd9a34afff',
        optimoveTenantId: '1950',
        optimoveTenantToken: '144e2e7971da435b9bfbbcd943866483',
        // TODO: replace with the real tenant ref issued for this brand.
        sportmodity: {
            enabled: true,
            tenantRef: 'YOUR_TENANT',
            sdkBaseUrl: 'https://betting-dev.sportsmodity.com',
            embedUrl: '/embed'
        }
        // betbyBrandId: '2521642017990250504',
        // betbyEnabled: true,
        // betbyScriptUrl: 'https://fomo.sptpub.com/bt-renderer.min.js',
        // gamityBrandRef: 'luna',
        // gamityCurrency: 'USDT',
        // gamityEnvironment: 'production',
        // integrationRef: 'visionlink-gametech-as',
        // microsoftClarityId: 'u0hhgckxig'
    }
];
export const endpointSetting = (appMode, // eslint-disable-line @typescript-eslint/no-unused-vars
domain, // eslint-disable-line @typescript-eslint/no-unused-vars
fullDomain // eslint-disable-line @typescript-eslint/no-unused-vars
) => {
    return endpointSettings[0];
};
